module.exports = __webpack_public_path__ + "media/assets/images/flags/ee-7e6f9ad6901f11ae874485b3185c1398.svg";